<template>
  <div class="h-screen overflow-hidden bg-background flex flex-col">
    <Header class="shrink-0" />
    <main class="min-h-0 flex-1 overflow-hidden">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
useHead({
  htmlAttrs: {
    class: 'payment-layout'
  },
  bodyAttrs: {
    class: 'payment-layout'
  }
})
</script>
